import React, { useContext } from "react";
import { IState } from "./interfaces";
import { reducer } from "./Actions";

const initialState: IState = {
  initialFetch: true,
  users: [],
  deletedUsers: [],
  showCacheRefreshModal: false,
  ignoreCacheCheck: null,
  metaJsonBuildId: ""
};

export const Store = React.createContext<IState | any>(initialState);

export function StoreProvider({
  children
}: JSX.ElementChildrenAttribute): JSX.Element {
  const [globalState, globalDispatch] = React.useReducer(reducer, initialState);
  return (
    <Store.Provider value={{ globalState, globalDispatch }}>
      {children}
    </Store.Provider>
  );
}

export const globalContext = () => useContext(Store);
